<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">{{categoryName}} Photos</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row" v-if="this.photos.length">
          <ItemCard
            v-for="photo in photos"
            :key="photo.id"
            :item="photo"
            :nextLink="getNextLink(photo.id)">
          </ItemCard>
        </div>
        <div class="not-found-div" v-else>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center">No photos found in {{categoryName}} category</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import ItemCard from '@/components/ItemCard'
export default {
  name: 'Photos',
  components: {
    ItemCard
  },
  watch: {
    '$route.params.category_id': function () {
      this.fetchPhotos()
    }
  },
  data () {
    return {
      LIFESTYLE_PHOTO_ID: process.env.LIFESTYLE_PHOTO_ID,
      RECIPE_PHOTO_ID: process.env.RECIPE_PHOTO_ID,
      photos: [],
      categoryName: ''
    }
  },
  mounted () {
    this.fetchPhotos()
  },
  methods: {
    fetchPhotos () {
      this.photos = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchPhotos', this.$route.params.category_id)
        .then((result) => {
          this.photos = result.data.photos
          $('.overlay').addClass('d-none')
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    getNextLink (photoId) {
      if (photoId === this.LIFESTYLE_PHOTO_ID || photoId === this.RECIPE_PHOTO_ID) {
        return '/photo/' + photoId + '/categories'
      }
      return '/photo/' + photoId + '/photo-images'
    }
  }
}

</script>

<style scoped>
.not-found-div {
  height: calc(70vh - 190px);
}
@media screen and (max-width: 500px){
  .not-found-div {
    height: calc(70vh - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Photos.vue